// Mirror of backend data/community_seo.py SEO_CATEGORIES (slug + label).
// Used to detect SEO category URLs and render the nationwide resource guides.
export const SEO_CATEGORIES = [
  { slug: 'housing-assistance', label: 'Housing Assistance' },
  { slug: 'food-assistance', label: 'Food Assistance' },
  { slug: 'utility-assistance', label: 'Utility Assistance' },
  { slug: 'transportation-assistance', label: 'Transportation Assistance' },
  { slug: 'funeral-end-of-life-assistance', label: 'Funeral & End-of-Life Assistance' },
  { slug: 'mental-health-resources', label: 'Mental Health Resources' },
  { slug: 'domestic-violence-resources', label: 'Domestic Violence Resources' },
  { slug: 'disability-resources', label: 'Disability Resources' },
  { slug: 'veteran-resources', label: 'Veteran Resources' },
  { slug: 'child-family-assistance', label: 'Child & Family Assistance' },
  { slug: 'senior-resources', label: 'Senior Resources' },
];

export const SEO_CATEGORY_SLUGS = new Set(SEO_CATEGORIES.map((c) => c.slug));
export const SEO_CATEGORY_LABEL = Object.fromEntries(SEO_CATEGORIES.map((c) => [c.slug, c.label]));
